import { useState, useEffect, useCallback } from "react";

export const usePagination = (items, defaultPerPage = 60) => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(defaultPerPage);

  useEffect(() => {
    setPage(0);
  }, [items]);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangePerPage = useCallback((event) => {
    setPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const paginatedItems = items.slice(page * perPage, page * perPage + perPage);

  return {
    page,
    perPage,
    handleChangePage,
    handleChangePerPage,
    paginatedItems,
    totalCount: items.length,
  };
};
